var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarginChart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_2924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2563 9.93124C12.8586 10.8715 12.2367 11.7001 11.4449 12.3446C10.6531 12.989 9.71549 13.4296 8.71403 13.628C7.71257 13.8263 6.67777 13.7763 5.7001 13.4824C4.72243 13.1884 3.83165 12.6594 3.10565 11.9416C2.37964 11.2239 1.84052 10.3392 1.5354 9.36496C1.23029 8.3907 1.16848 7.35654 1.35538 6.35288C1.54228 5.34923 1.97219 4.40663 2.60754 3.60751C3.24288 2.80838 4.06431 2.17706 5.00001 1.76874",
    stroke: "#001489",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5C13.75 6.67924 13.5883 5.86651 13.2742 5.10823C12.9602 4.34994 12.4998 3.66095 11.9194 3.08058C11.3391 2.50022 10.6501 2.03984 9.89177 1.72575C9.13349 1.41166 8.32076 1.25 7.5 1.25V7.5H13.75Z",
    stroke: "#001489",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_2924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarginChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/margin-chart.924156bf60b57d90273cedf80788d40a.svg";